"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUserToTopLikedBy = addUserToTopLikedBy;
exports.removeUserFromTopLikedBy = removeUserFromTopLikedBy;
exports.updateLikedByState = updateLikedByState;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var MAX_PREVIEW_USERS = 3;

function addUserToTopLikedBy(topLikedBy, user) {
  var isAlreadyInArray = topLikedBy.some(function (likedUser) {
    return likedUser.id === user.id;
  });
  return isAlreadyInArray ? topLikedBy : [].concat((0, _toConsumableArray2.default)(topLikedBy), [user]).slice(0, MAX_PREVIEW_USERS);
}

function removeUserFromTopLikedBy(topLikedBy, userId) {
  return topLikedBy.filter(function (user) {
    return user.id !== userId;
  });
}

function updateLikedByState(prevLikedBy, prevTopLikedBy, normalizedCurrentUser, hasCurrentUserLiked) {
  var currentUserIdStr = normalizedCurrentUser.id.toString();
  var currentUserIdNum = normalizedCurrentUser.id;
  var updatedLikedBy = hasCurrentUserLiked ? [].concat((0, _toConsumableArray2.default)(prevLikedBy), [currentUserIdStr]) : prevLikedBy.filter(function (id) {
    return id !== currentUserIdStr;
  });
  var updatedTopLikedBy = hasCurrentUserLiked ? addUserToTopLikedBy(prevTopLikedBy, normalizedCurrentUser) : removeUserFromTopLikedBy(prevTopLikedBy, currentUserIdNum);
  return {
    hasCurrentUserLiked: hasCurrentUserLiked,
    likedBy: updatedLikedBy,
    topLikedBy: updatedTopLikedBy
  };
}